import Ajax from '../ajax';

export default {
  list: (filter) => Ajax('get', 'shoppingGiveBackMerchant', filter),
  get: (id) => Ajax('get', `shoppingGiveBackMerchant/${id}`),
  add: (data) => Ajax('post', 'shoppingGiveBackMerchant', data),
  edit: (id, data) => Ajax('put', `shoppingGiveBackMerchant/${id}`, data),
};
